import { useEffect } from 'react';
import { useFetcher } from '@remix-run/react';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import ArticlesCarouselDesktop from '../../../articles/component/articles-carousel/ArticlesCarousel.desktop';
import ArticlesCarouselMobile from '../../../articles/component/articles-carousel/ArticlesCarousel.mobile';
import type { ArticleGroupTypes } from '~/modules/articles/type';
import {
    type loader as articleLoader,
    HREF_ARTICLE_TILES,
} from '~/routes/remix-api.article.get-article-tiles';
import ArticleCarouselPlaceholder from '~/modules/articles/component/article-tile-skeleton/ArticleCarouselPlaceholder';

const TopReadArticles: React.FC = () => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const fetcher = useFetcher<typeof articleLoader>();
    const topReadArticles = fetcher.data;

    useEffect(() => {
        if (fetcher.state === 'idle' && fetcher.data == null) {
            fetcher.load(
                `${HREF_ARTICLE_TILES}?limit=5&searchSort=popular&monthFilter=true&randomSort=true`
            );
        }
    }, [fetcher]);

    const args = {
        title: 'TOP READS',
        articleType: 'TopRead' as ArticleGroupTypes,
    };

    return topReadArticles === undefined ? (
        <ArticleCarouselPlaceholder title={args.title} />
    ) : (
        <>
            {isMobile ? (
                <ArticlesCarouselMobile
                    {...args}
                    articleTiles={topReadArticles}
                />
            ) : (
                <ArticlesCarouselDesktop
                    {...args}
                    articleTiles={topReadArticles}
                />
            )}
        </>
    );
};

export default TopReadArticles;
